import React from 'react';
import { useTranslation } from 'react-i18next';
import InfoPage from '../../InfoPage';

export default function RatingsInformation() {
  const { t } = useTranslation();
  // Rating CODES (G, PG-13...) are classification identifiers and stay as
  // printed on the certificate; the names and explanations translate.
  const ratings = t('ratings.items', { returnObjects: true }) || [];
  return (
    <InfoPage
      eyebrow={t('info.moviesEyebrow')}
      title={t('ratings.title')}
      subtitle={t('ratings.subtitle')}
    >
      <div className="info-grid">
        {ratings.map((r) => (
          <div key={r.code} className="info-card">
            <h3>{r.code} — {r.name}</h3>
            <p>{r.desc}</p>
          </div>
        ))}
      </div>

      <h2>{t('ratings.howShown')}</h2>
      <p>{t('ratings.howShownCopy')}</p>

      <h2>{t('ratings.idChecks')}</h2>
      <p>{t('ratings.idChecksCopy')}</p>
    </InfoPage>
  );
}
